'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useClearRefinements, useRefinementList } from 'react-instantsearch';
import MobileOnly from 'components/consumer/MobileOnly';
import MobileModal from 'components/consumer/MobileModal';
import CtaButton from 'components/essentials/Cta/CtaButton';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import WidthRangeFilter from 'components/consumer/consumer-search/advanced-search-next/components/WidthRangeFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import getAdvancedSearchActiveFilterCount from 'components/consumer/consumer-search/advanced-search-next/hooks/getAdvancedSearchActiveFilterCount';
import MobileProductFiltersButton from 'components/consumer/consumer-search/advanced-search-next/components/AlgoliaHits/components/MobileProductFilters/components/MobileProductFiltersButton';
import MobileProductListingColorFilter from 'components/consumer/consumer-search/advanced-search-next/components/AlgoliaHits/components/MobileProductFilters/components/MobileProductListingColorFilter';
import ProductClearAllFiltersButton from 'components/consumer/consumer-search/advanced-search-next/components/AlgoliaHits/components/MobileProductFilters/components/ProductClearAllFiltersButton';
import MobileProductListingFilterWrapper from 'components/consumer/ProductListingPage/components/mobile/MobileProductListingFiltersButtonAndModal/MobileProductListingFilterWrapper';
import CategoryAlgoliaMobileFacetFilter from '../CategoryAlgoliaMobileFacetFilter';
const SKIP_FILTER_IDS = new Set(['quickship', 'color', 'widthRange', 'search']);
const CategoryAlgoliaMobileFilters = t0 => {
  const $ = _c(58);
  const {
    filters,
    selectedFacets,
    onToggleFacet,
    productsCount
  } = t0;
  const {
    clearSelectedColors,
    clearSelectedFacets,
    isReadyToShipActive,
    handleToggleReadyToShip,
    minWidth,
    maxWidth,
    handleWidthChange
  } = useAdvancedSearchContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      attribute: "option_color",
      skipSuspense: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    items: colorFilters,
    refine: refineColorFilters
  } = useRefinementList(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      includedAttributes: ["option_color"]
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    canRefine: canClearColorRefinements,
    refine: clearColorRefinement
  } = useClearRefinements(t2);
  let t3;
  if ($[2] !== filters) {
    t3 = filters || [];
    $[2] = filters;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = t3.filter(_temp);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const dynamicFilters = t4;
  let t5;
  if ($[6] !== selectedFacets) {
    t5 = Object.values(selectedFacets || {}).some(_temp2) || false;
    $[6] = selectedFacets;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const hasSelectedFacets = t5;
  const canClear = hasSelectedFacets || canClearColorRefinements || isReadyToShipActive || !!(minWidth || maxWidth);
  const [isMobileFiltersModalOpen, setIsMobileFiltersModalOpen] = useState(false);
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsMobileFiltersModalOpen(true);
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleOpenModal = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsMobileFiltersModalOpen(false);
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleCloseModal = t7;
  let t8;
  if ($[10] !== clearColorRefinement || $[11] !== clearSelectedColors || $[12] !== clearSelectedFacets || $[13] !== handleToggleReadyToShip || $[14] !== handleWidthChange || $[15] !== isReadyToShipActive || $[16] !== maxWidth || $[17] !== minWidth) {
    t8 = () => {
      clearSelectedFacets?.();
      clearColorRefinement();
      clearSelectedColors?.();
      if (isReadyToShipActive) {
        handleToggleReadyToShip?.(false);
      }
      if (minWidth || maxWidth) {
        handleWidthChange?.("", "");
      }
    };
    $[10] = clearColorRefinement;
    $[11] = clearSelectedColors;
    $[12] = clearSelectedFacets;
    $[13] = handleToggleReadyToShip;
    $[14] = handleWidthChange;
    $[15] = isReadyToShipActive;
    $[16] = maxWidth;
    $[17] = minWidth;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const clearRefinement = t8;
  let t9;
  if ($[19] !== colorFilters || $[20] !== isReadyToShipActive || $[21] !== maxWidth || $[22] !== minWidth || $[23] !== selectedFacets) {
    t9 = getAdvancedSearchActiveFilterCount({
      colorItems: colorFilters,
      selectedFacets,
      isReadyToShipActive,
      minWidth,
      maxWidth
    });
    $[19] = colorFilters;
    $[20] = isReadyToShipActive;
    $[21] = maxWidth;
    $[22] = minWidth;
    $[23] = selectedFacets;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const activeFilterCount = t9;
  let t10;
  if ($[25] !== activeFilterCount) {
    t10 = <MobileProductFiltersButton activeFilterCount={activeFilterCount} onClick={handleOpenModal} />;
    $[25] = activeFilterCount;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== canClear || $[28] !== clearRefinement) {
    t11 = <ProductClearAllFiltersButton canClear={canClear} clearRefinement={clearRefinement} />;
    $[27] = canClear;
    $[28] = clearRefinement;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const t12 = productsCount || 0;
  const t13 = productsCount === 1 ? "" : "s";
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <CtaButton block={true} onClick={handleCloseModal}>Done ({t12} result{t13})</CtaButton>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const t15 = activeFilterCount > 0 ? `Filters (${activeFilterCount})` : "Filters";
  let t16;
  if ($[33] !== handleToggleReadyToShip || $[34] !== isReadyToShipActive) {
    t16 = <MobileProductListingFilterWrapper id="quickship"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} showLabelOnMobile={true} /></MobileProductListingFilterWrapper>;
    $[33] = handleToggleReadyToShip;
    $[34] = isReadyToShipActive;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <MobileProductListingFilterWrapper id="widthRange" label="Width"><WidthRangeFilter /></MobileProductListingFilterWrapper>;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== dynamicFilters || $[38] !== onToggleFacet || $[39] !== selectedFacets) {
    let t19;
    if ($[41] !== onToggleFacet || $[42] !== selectedFacets) {
      t19 = filter_0 => <MobileProductListingFilterWrapper id={filter_0.id} key={filter_0.id} label={filter_0.label}><CategoryAlgoliaMobileFacetFilter attribute={filter_0.id} label={filter_0.label} options={filter_0.options} selectedValues={selectedFacets?.[filter_0.id] || new Set()} onToggle={onToggleFacet} /></MobileProductListingFilterWrapper>;
      $[41] = onToggleFacet;
      $[42] = selectedFacets;
      $[43] = t19;
    } else {
      t19 = $[43];
    }
    t18 = dynamicFilters.map(t19);
    $[37] = dynamicFilters;
    $[38] = onToggleFacet;
    $[39] = selectedFacets;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[44] !== colorFilters || $[45] !== refineColorFilters) {
    t19 = <MobileProductListingColorFilter colorFilters={colorFilters} refineColorFilters={refineColorFilters} />;
    $[44] = colorFilters;
    $[45] = refineColorFilters;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== isMobileFiltersModalOpen || $[48] !== t11 || $[49] !== t14 || $[50] !== t15 || $[51] !== t16 || $[52] !== t18 || $[53] !== t19) {
    t20 = <MobileOnly><div className="md:hidden"><MobileModal enableHashHistory={false} headerRight={t11} isFullHeight={true} isOpen={isMobileFiltersModalOpen} onClose={handleCloseModal} stickyFooter={t14} title={t15}>{t16}{t17}{t18}{t19}</MobileModal></div></MobileOnly>;
    $[47] = isMobileFiltersModalOpen;
    $[48] = t11;
    $[49] = t14;
    $[50] = t15;
    $[51] = t16;
    $[52] = t18;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== t10 || $[56] !== t20) {
    t21 = <>{t10}{t20}</>;
    $[55] = t10;
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  return t21;
};
CategoryAlgoliaMobileFilters.propTypes = {
  filters: PropTypes.array,
  selectedFacets: PropTypes.object,
  onToggleFacet: PropTypes.func,
  productsCount: PropTypes.number
};
export default CategoryAlgoliaMobileFilters;
function _temp(filter) {
  return !SKIP_FILTER_IDS.has(filter.id) && filter.options?.length > 0;
}
function _temp2(values) {
  return values?.size > 0;
}